import ACS from '../edit/ACS';
import DirectRouting from '../edit/DirectRouting';
import OperatorConnect from '../edit/OperatorConnect';
import SBCaaS from '../edit/SBCaaS';
import TPM from '../edit/TPM';
import SelectProfile from './SelectProfile';
import OCC from '../edit/OCC';
import AddVendorDefined from '../vendorDefined/AddVendorDefined';
import EditVendorDefined from '../vendorDefined/EditVendorDefined';
import { DefinedAttributesProvider } from '../vendorDefined/DefinedAttributesContext';
import Zoom from '../edit/Zoom';
import EightByEight from 'pages/services/serviceprofiles/edit/EightByEight';
import GCCHighServiceProfile from 'pages/services/serviceprofiles/edit/GCCHighServiceProfile';
import WebexServiceProfile from '../edit/WebexServiceProfile';
import OperatorPlatformServiceProfile from '../edit/OperatorPlatformServiceProfile';
import SRTServiceProfile from '../edit/SRT';
import GenericServiceProfileForm from '../edit/GenericServiceProfileForm';
import { getGenericSimpleServiceProfilePlatform } from 'services/platformRegistry';
import { GCC_HIGH, SRT, WEBEX } from 'pages/dashboards/v5/constants';

export default function Form({
    mode = 'ADD',
    data,
    handleBackButton,
    level,
    handleSelectServiceProfileType,
    scopeList,
    filterFn,
    selectTitle,
}) {
    const visibleScopeOptions = scopeList();

    const serviceTypeSelected = data?.serviceType.includes('VendorDefined')
        ? data?.serviceType.split('|')[0]
        : data?.serviceType;

    switch (serviceTypeSelected) {
        case 'TeamsPhoneMobile':
            return (
                <TPM
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'SBCaaS':
            return (
                <SBCaaS
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'OperatorConnect':
            return (
                <OperatorConnect
                    mode={mode}
                    level={level}
                    data={mode === 'EDIT' ? data : null}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'DirectRouting':
            return (
                <DirectRouting
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'ACSDirectRouting':
            return (
                <ACS
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'OperatorConnectConferencing':
            return (
                <OCC
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'VendorDefined':
            return (
                <DefinedAttributesProvider>
                    {mode === 'EDIT' ? (
                        <EditVendorDefined
                            data={data}
                            level={level}
                            handleBackButton={handleBackButton}
                            visibleScopeOptions={visibleScopeOptions}
                        />
                    ) : (
                        <AddVendorDefined
                            data={data}
                            level={level}
                            handleBackButton={handleBackButton}
                            visibleScopeOptions={visibleScopeOptions}
                        />
                    )}
                </DefinedAttributesProvider>
            );
        case 'OperatorPlatform':
            return (
                <OperatorPlatformServiceProfile
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'ZoomPEX':
            return (
                <Zoom
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case 'EightByEight':
            return (
                <EightByEight
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case GCC_HIGH:
            return (
                <GCCHighServiceProfile
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case WEBEX:
            return (
                <WebexServiceProfile
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        case SRT:
            return (
                <SRTServiceProfile
                    mode={mode}
                    data={mode === 'EDIT' ? data : null}
                    level={level}
                    handleBackButton={handleBackButton}
                    visibleScopeOptions={visibleScopeOptions}
                />
            );
        default: {
            const genericPlatform =
                getGenericSimpleServiceProfilePlatform(serviceTypeSelected);
            if (genericPlatform) {
                return (
                    <GenericServiceProfileForm
                        serviceType={genericPlatform.serviceType}
                        displayName={genericPlatform.displayName}
                        mode={mode}
                        data={mode === 'EDIT' ? data : null}
                        level={level}
                        handleBackButton={handleBackButton}
                        visibleScopeOptions={visibleScopeOptions}
                    />
                );
            }
            // default: ADD mode
            return (
                <SelectProfile
                    level={level}
                    handleBackButton={handleBackButton}
                    handleSelectServiceProfileType={
                        handleSelectServiceProfileType
                    }
                    filterFn={filterFn}
                    title={selectTitle}
                />
            );
        }
    }
}
